<template>
	<v-container id="dashboard-view" fluid tag="section">
		<v-row>
			<v-col cols="12" md="6" lg="3">
				<material-stat-card v-bind="stats.customers">
					<template #subtitle>
					</template>
					<template #actions>
						<v-icon class="mr-2" small> {{ stats.customers.actionIcon }} </v-icon>
						<div class="text-truncate" v-html="stats.customers.actionText" />
					</template>
				</material-stat-card>
			</v-col>
			<v-col cols="12" md="6" lg="3">
				<material-stat-card v-bind="stats.requests">
					<template #actions>
						<v-icon class="mr-2" small> {{ stats.requests.actionIcon }} </v-icon>
						<div class="text-truncate" v-html="stats.requests.actionText" />
					</template>
					<div class="text-center">

					</div>
				</material-stat-card>
			</v-col>
			<v-col cols="12" md="6" lg="3">
				<material-stat-card v-bind="stats.loans">
					<template #actions>
						<v-icon class="mr-2" small> {{ stats.loans.actionIcon }} </v-icon>
						<div class="text-truncate" v-html="stats.loans.actionText" />
					</template>
					<div class="text-center">
						<div class="text-h4 v-card__subtitle--material-stats">
							<div class="text-h5"><small class="grey--text">تعداد:</small> <span>{{ stats.loans.count }}</span></div>
							<div class="text-h5"><small class="grey--text">مجموع مبلغ:</small> <span>{{ stats.loans.total }} </span>
							</div>
							<div class="text-h5"><small class="grey--text">تعداد تسویه:</small> <span>{{ stats.loans.checkouts }}
								</span></div>
						</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" md="6" lg="3">
				<material-stat-card v-bind="stats.paids">
					<template #actions>
						<v-icon class="mr-2" small> {{ stats.paids.actionIcon }} </v-icon>
						<div class="text-truncate" v-html="stats.paids.actionText" />
					</template>
					<div class="text-center">
						<div class="text-h4 v-card__subtitle--material-stats">
							<div class="text-h5"><small class="grey--text">سهم شما:</small> <span>{{ stats.paids.total }}</span>
							</div>
							<div class="text-h5"><small class="grey--text">پرداخت شده توسط اسپانسر:</small> <span>{{
								stats.paids.receiveds }} </span></div>
						</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" md="6" lg="3">
				<material-stat-card v-bind="stats.overdue">
					<template #subtitle>
						<div style="cursor:pointer" @click="viewOverDueInstallments">
							اقساط سررسید شده و معوق ها
						</div>
					</template>
					<template #actions>
						<v-icon class="mr-2" small> {{ stats.overdue.actionIcon }} </v-icon>
						<div class="text-truncate" v-html="stats.overdue.actionText" />
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewOverDueInstallments">
						<!-- <div class="text-h4 v-card--material__title pl-3">
							اقساط سررسید شده و معوق ها
						</div> -->
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ stats.overdue.value.toString().toPriceFormat() }} تومان
						</div>
						<div>{{ stats.overdue.count.toString() }} مورد</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" md="6" lg="3">
				<material-stat-card v-bind="stats.ticket">
					<template #subtitle>
						<div style="cursor:pointer" @click="routeToTickets">
							تیکت پاسخ داده شده
						</div>
					</template>
					<template #actions>
						<v-icon class="mr-2" small> {{ stats.ticket.actionIcon }} </v-icon>
						<div class="text-truncate" v-html="stats.ticket.actionText" />
					</template>
					<div class="text-center" style="cursor:pointer" @click="routeToTickets">
						<!-- <div class="text-h4 v-card--material__title pl-3">
							اقساط سررسید شده و معوق ها
						</div> -->
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ stats.ticket.count }}
						</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" md="6" lg="3">
				<material-stat-card v-bind="sponsoreOverdueStat">
					<template #subtitle>
						<div style="cursor:pointer" @click="viewSponsoreOverdue">
							سررسید شده های اسپانسر به شما
						</div>
					</template>
					<template #actions>
						<v-icon class="mr-2" small> {{ sponsoreOverdueStat.actionIcon }} </v-icon>
						<div class="text-truncate" v-html="sponsoreOverdueStat.actionText"></div>
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewSponsoreOverdue">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ sponsoreOverdueStat.value.toString().toPriceFormat() }} تومان
						</div>
						<div>{{ sponsoreOverdueStat.count.toString() }} مورد</div>
					</div>
				</material-stat-card>
			</v-col>

			<v-col cols="12" md="6" lg="3" v-if="!hasParentAgent">
				<material-stat-card v-bind="subAgentOverdueStat">
					<template #subtitle>
						<div style="cursor:pointer" @click="viewAgentOverdue">
							سررسید شده های سهم زیر مجموعه ها
						</div>
					</template>
					<template #actions>
						<v-icon class="mr-2" small> {{ subAgentOverdueStat.actionIcon }} </v-icon>
						<div class="text-truncate" v-html="subAgentOverdueStat.actionText"></div>
					</template>
					<div class="text-center" style="cursor:pointer" @click="viewAgentOverdue">
						<div class="text-h4 v-card__subtitle--material-stats">
							{{ subAgentOverdueStat.value.toString().toPriceFormat() }} تومان
						</div>
						<div>{{ subAgentOverdueStat.count.toString() }} مورد</div>
					</div>
				</material-stat-card>
			</v-col>



			<v-col cols="12" md="6" class="pa-0 ma-0">
				<v-row class="pa-0 ma-0">
					<v-col cols="12">
						<v-card class="px-3">
							<div style="padding:10px 5px;border-bottom: 1px dashed #ddd;" class="">لینک های تبلیغاتی شما:
							</div>
							<div v-if="loadingPlans" class="pa-3 text-center success--text">در حال دریافت اطلاعات...</div>
							<div v-else>
								<div v-for="plan in plans" :key="plan.id" class="pa-2" style="border-bottom: 1px dashed #ddd;">
									<div class="text-center">{{ plan.title }}</div>
									<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
										<v-btn @click="copyToClipborad(plan)" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
											<v-icon color="white">mdi-content-copy</v-icon>
										</v-btn>
										<span style="cursor: pointer;" class="info--text" @click="copyToClipborad(plan)">
											{{ getLink(plan) }}
										</span>
									</div>
								</div>
							</div>
							<div v-if="!loadingPlans">
								<div class="text-center">لینک به صفحه اصلی</div>
								<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
									<v-btn @click="copyToClipborad(plan)" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
										<v-icon color="white">mdi-content-copy</v-icon>
									</v-btn>
									<span style="cursor: pointer;" class="info--text" @click="copyToClipborad()">{{ getLink() }}</span>
								</div>
							</div>
							<div v-if="!loadingPlans">
								<div class="text-center">لینک به صفحه ثبت نام</div>
								<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
									<v-btn @click="copyToClipborad('register')" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
										<v-icon color="white">mdi-content-copy</v-icon>
									</v-btn>
									<span style="cursor: pointer;" class="info--text" @click="copyToClipborad('register')">{{ getLink('register') }}</span>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</v-col>

			<v-col cols="12" sm="12" md="6" v-if="dashboardSettings.digitalSignContracts && checkActivePart('digitalSign')">
				<latestDigitalSign-contracts-widget area="agent" />
			</v-col>

		</v-row>

		<v-dialog v-model="dialogOverDueInstallments" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست اقساط سررسید شده و معوق</span></div>
					<v-spacer />
					<v-btn @click="dialogOverDueInstallments = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<over-due-installments ref="installments" v-if="dialogOverDueInstallments" @changed="loadData" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSubAgentOverDue" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست سررسید شده های سهم زیر مجموعه ها</span></div>
					<v-spacer />
					<v-btn @click="dialogSubAgentOverDue = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<subAgent-over-due v-if="dialogSubAgentOverDue" @changed="loadData" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSponsoreOverDue" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست سررسید شده های اسپانسر</span></div>
					<v-spacer />
					<v-btn @click="dialogSponsoreOverDue = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<sponsore-over-due v-if="dialogSponsoreOverDue" @changed="loadData" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>


	</v-container>
</template>

<script>
	// Utilities
	import { get } from 'vuex-pathify'
	import Vue from 'vue'
	import api from '@/util/app-api'
	import router from '@/router'
	import toast from '@/util/toast'

	const lineSmooth = Vue.chartist.Interpolation.cardinal({
		tension: 0,
	})

	export default {
		name: 'AgentDashboardView',
		components: {
			'sponsore-over-due': () => import('./SponsoreOverDue.vue'),
			'subAgent-over-due': () => import('./sub-agent/SubAgentOverDue.vue'),
			'latestDigitalSign-contracts-widget': () => import('@/components/dashboardWidgets/LatestDigitalSignContractsWidget.vue'),
			'over-due-installments': () => import('./OverDueInstallments.vue')
		},
		data: () => ({
			dialogSubAgentOverDue: false,
			dialogOverDueInstallments: false,
			dialogSponsoreOverDue: false,
			loadingPlans: false,
			items: [],
			plans: [],
			loans: [],
			stats: {
				customers: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'primary',
					icon: 'mdi-account-multiple',
					iconSmall: true,
					title: 'تعداد مشتری',
					value: '',
				},
				loans: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'primary',
					icon: 'mdi-account-cash',
					iconSmall: true,
					title: 'آمار پرونده های وام',
					count: '',
					total: '',
					checkouts: '',
				},
				paids: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'success',
					icon: 'mdi-cash-check',
					iconSmall: true,
					title: 'مالی',
					total: '',
					receiveds: '',
				},
				requests: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'info',
					icon: 'mdi-cash-remove',
					iconSmall: true,
					title: 'آمار درخواست وام ها',
					value: '',
				},
				overdue: {
					actionIcon: 'mdi-tag',
					actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
					color: 'secondary',
					icon: 'mdi-flower-tulip',
					iconSmall: true,
					title: '',
					value: '',
					count: '0'
				},
				ticket: {
					actionIcon: 'mdi-tag',
					actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
					color: 'green',
					icon: 'mdi-email-fast',
					iconSmall: true,
					title: '',
					value: '',
					count: '0'
				}
			},
			subAgentOverdueStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'success',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			sponsoreOverdueStat: {
				actionIcon: 'mdi-tag',
				actionText: 'جهت مشاهده بر روی باکس کلیک کنید',
				color: 'secondary',
				icon: 'mdi-flower-tulip',
				iconSmall: true,
				title: '',
				value: '',
				count: '0'
			},
			tabs: 0,
		}),

		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			...get('siteConfig', [
				'isCloud', 'baseUrl'
			]),
			customerCode() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer)
					return `${user.userData.customer.code}`
				return ''
			},
			hasParentAgent() {
				var user = this.getCurrentUser
				return !!user?.userData?.agentId
			}
		},

		mounted() {
			this.loadData()
			this.loadPlans()
		},
		methods: {
			loadPlans() {
				this.loadingPlans = false
				return api.get('agent/UserLoanRequest/LoansList', null)
					.then(
						response => {
							this.plans = response.filter(x => x.includePlan && !x.disable)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loadingPlans = false
					})
			},
			loadData() {
				api.get('agent/dashboard/get', null)
					.then(
						response => {
							this.stats.customers.value = response.memberCount + ''
							this.stats.loans.count = response.allLoansCount + ''
							this.stats.loans.total = response.totalLoans.toString().toPriceFormat() + ' تومان'
							this.stats.loans.checkouts = response.allCheckoutedCount + ''
							this.stats.paids.total = response.totalAgentShare.toString().toPriceFormat() + ' تومان'
							this.stats.paids.receiveds = response.totalReceivedsBySponsore.toString().toPriceFormat() + ' تومان'
							this.stats.requests.value = response.allLoanRequestsCount + ''

							this.stats.overdue.value = response.overDueInstallments.sumByDelays.toString()
							this.stats.overdue.count = response.overDueInstallments.count.toString()

							this.stats.ticket.count = response.ticketsCount.toString()

							this.subAgentOverdueStat.value = response.subAgentOverdue.total.toString()
							this.subAgentOverdueStat.count = response.subAgentOverdue.count.toString()

							this.sponsoreOverdueStat.value = response.agentOverdue.total.toString()
							this.sponsoreOverdueStat.count = response.agentOverdue.count.toString()
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			viewOverDueInstallments() {
				this.dialogOverDueInstallments = true
			},
			viewAgentOverdue() {
				this.dialogSubAgentOverDue = true
			},
			viewSponsoreOverdue() {
				this.dialogSponsoreOverDue = true
			},
			routeToTickets() {
				router.push({ path: '/Agent/Tickets' }).catch(() => { })
			},
			copyToClipborad(plan) {
				const fallbackCopyTextToClipboard = () => {
					var el = document.createElement('textarea')
					el.value = text
					el.setAttribute('readonly', '')
					el.style = {
						position: 'absolute',
						left: '-9999px'
					}
					document.body.appendChild(el)
					el.select()
					document.execCommand('copy')
					document.body.removeChild(el)
					toast.success('لینک به حافظه کپی شد.')
				}
				var text = this.getLink(plan)
				if (!navigator.clipboard) {
					fallbackCopyTextToClipboard(text)
					return
				}
				navigator.clipboard.writeText(text).then(function () {
					toast.success('لینک به حافظه کپی شد.')
				}, function (err) {
					console.error('Async: Could not copy text: ', err)
				})
			},
			getLink(plan) {
				if (!plan)
					return `${this.baseUrl}/cl/plans/${(this.isCloud ? this.customerCode + '/' : '0/')}?agn=` + this.getCurrentUser.userData.id

				if (plan === 'register')
					return `${this.baseUrl}/register/${(this.isCloud ? this.customerCode + '/' : '0/')}?agn=` + this.getCurrentUser.userData.id

				return `${this.baseUrl}/cl/plan/${(this.isCloud ? this.customerCode + '/' : '0/')}${plan.code}/?agn=` + this.getCurrentUser.userData.id
			}
		}
	}
</script>
<style>

	svg.ct-chart-bar,
	svg.ct-chart-line {
		overflow: visible;
	}

	.ct-label.ct-label.ct-horizontal.ct-end {
		position: relative;
		justify-content: flex-end;
		text-align: right;
		transform-origin: 100% 0;
		transform: translate(-100%) rotate(-45deg);
		white-space: nowrap;
	}

	.ct-label.ct-vertical.ct-start {
		white-space: pre;
		transform: translateX(-5px);
	}
</style>
